const QuestionTypes = Object.freeze({
  multipleChoice: "multiple-choice",
});

export default QuestionTypes;
